import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);

window.Application = require('./application.js').default;
window.Common = require('./common.js').default;

const Home = resolve => require(['./pages/Home.vue'], resolve);

const About = resolve => require(['./pages/company/About.vue'], resolve);
const Career = resolve => require(['./pages/company/Career.vue'], resolve);
const Documents = resolve => require(['./pages/company/Documents.vue'], resolve);
const Contacts = resolve => require(['./pages/company/Contacts.vue'], resolve);

const NewsList = resolve => require(['./pages/NewsList.vue'], resolve);

const BidPro = resolve => require(['./pages/solutions/BidPro.vue'], resolve);
const Loyalty = resolve => require(['./pages/solutions/Loyalty.vue'], resolve);
const GlobalCentre = resolve => require(['./pages/solutions/GlobalCentre.vue'], resolve);
const ResourceManagement = resolve => require(['./pages/solutions/ResourceManagement.vue'], resolve);
const Aspa = resolve => require(['./pages/solutions/Aspa.vue'], resolve);
const Platform = resolve => require(['./pages/solutions/Platform.vue'], resolve);
const CloudCredit = resolve => require(['./pages/solutions/CloudCredit.vue'], resolve);

const Engineering = resolve => require(['./pages/services/Engineering.vue'], resolve);
const Development = resolve => require(['./pages/services/Development.vue'], resolve);
const Consulting = resolve => require(['./pages/services/Consulting.vue'], resolve);

const router = new VueRouter({
    mode: 'history',
    routes: [
        { path: '/:lang?/company/about', component: About, canReuse: true },
        { path: '/:lang?/company/career', component: Career, canReuse: true },
        { path: '/:lang?/company/documents', component: Documents, canReuse: true },
        { path: '/:lang?/company/contacts', component: Contacts, canReuse: true },

        { path: '/:lang?/news', component: NewsList, canReuse: true },

        { path: '/:lang?/solutions/bid-pro', component: BidPro, canReuse: true },
        { path: '/:lang?/solutions/loyalty', component: Loyalty, canReuse: true },
        { path: '/:lang?/solutions/global-centre', component: GlobalCentre, canReuse: true },
        { path: '/:lang?/solutions/resource-management', component: ResourceManagement, canReuse: true },
        { path: '/:lang?/solutions/aspa', component: Aspa, canReuse: true },
        { path: '/:lang?/solutions/platform', component: Platform, canReuse: true },
        { path: '/:lang?/solutions/cloud-credit', component: CloudCredit, canReuse: true },

        { path: '/:lang?/services/engineering', component: Engineering, canReuse: true },
        { path: '/:lang?/services/development', component: Development, canReuse: true },
        { path: '/:lang?/services/consulting', component: Consulting, canReuse: true },

        { path: '/:lang?', component: Home, canReuse: true }
    ]
});

window.VueRouter = router;

const app = new Vue({
    el: '#app',
    router: router,
    data: {
        currentRoute: window.location.pathname
    },
    render (h) {
        return h(require('./layouts/Main.vue'));
    }
});


// WEBPACK FOOTER //
// ./src/main.js